module.exports = __webpack_public_path__ + "img/client-tb.91d6750a.svg";